var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5V6.5C16.56 5.92 20 3.4 20 0.5H0C0 3.4 3.44 5.92 8 6.5V9.5C4.32 10.23 0 13.11 0 20.5H6V18.5H2.13C3.06 11.67 8.78 11.3 10 11.3C11.22 11.3 16.94 11.67 17.87 18.5H14V20.5H20C20 13.11 15.68 10.23 12 9.5ZM16.87 2.5C15.5 3.69 13 4.62 10 4.62C7 4.62 4.5 3.69 3.13 2.5H16.87ZM10 20.5C8.9 20.5 8 19.6 8 18.5C8 17.95 8.22 17.45 8.59 17.09C9.39 16.29 14 14.5 14 14.5C14 14.5 12.21 19.11 11.41 19.91C11.05 20.28 10.55 20.5 10 20.5Z",
    fill: "#DAD7D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.b3f53baf833be690de62f9582b705133.svg";
export { ForwardRef as ReactComponent };